/* eslint-disable max-lines-per-function */
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { isInlineEditInProgress } from 'reactApp/modules/modifying/modifying.selectors';
import { resetSelect } from 'reactApp/modules/selections/selections.actions';
import { onClickCreateNew, onItemClick } from 'reactApp/ui/Datalist/UserActions/onClickAction';
import { onContextMenu, onContextMenuItem } from 'reactApp/ui/Datalist/UserActions/onContextMenuAction';
import { onDocumentClick } from 'reactApp/ui/Datalist/UserActions/onDocumentAction';
import { onBeginSelection, onSelect, onSelectBoxSelection, onSelecting } from 'reactApp/ui/Datalist/UserActions/onSelectAction';

export const useHandleCallback = ({
    isModalOpen,
    setActiveIndex,
    dispatch,
    selectedItem,
    prevSelectHandler,
    storage,
    gaSuffix,
    items,
    selectedIdxs,
    selectingIdxs,
    setSelectingIdxs,
    goTo,
    routerParams,
    itemCreateNewRef,
    viewMode,
    isPopup,
    onItemSelectCallback,
    attachType,
    attachFolderId,
    currentAllDocsType,
}) => {
    const isInlineEditing = useSelector(isInlineEditInProgress);

    const handleOnDocumentClick = useCallback(
        (event: MouseEvent) => {
            onDocumentClick({ event, isModalOpen, setActiveIndex, dispatch, isInlineEditing });
        },
        [resetSelect, dispatch, isModalOpen, selectedItem, isInlineEditing]
    );

    const handleOnSelectGroupClick = useCallback((e) => {
        e.nativeEvent.stopImmediatePropagation();
        // На mousedown в SelectableGroup срабатывает onBeginSelection
        // Но не срабатывает onEndSelection
        // Поэтому дополнительно восстановим onselectstart на click
        document.onselectstart = prevSelectHandler.current;
    }, []);

    const handleBeginSelection = useCallback(
        (event) => {
            onBeginSelection({ event, dispatch, prevSelectHandler, itemCreateNewRef, isInlineEditing });
        },
        [resetSelect, dispatch, prevSelectHandler, isInlineEditing]
    );

    const handleOnContextMenu = useCallback(
        (event) => {
            onContextMenu({ event, gaSuffix, storage, isPopup });
        },
        [storage, gaSuffix, isPopup]
    );

    const handleOnContextMenuItem = useCallback(
        (event) => {
            onContextMenuItem({ event, gaSuffix, storage });
        },
        [storage]
    );

    const handleOnSelect = useCallback(
        ({ event, id, isCheckbox }: { event: React.MouseEvent; id: string; isCheckbox?: boolean }): void => {
            onSelect({ event, setActiveIndex, items, id, isCheckbox, storage, dispatch });
            onItemSelectCallback?.({ id });
        },
        [dispatch, items, storage, setActiveIndex, onItemSelectCallback]
    );

    const handleSelectboxSelection = useCallback(
        (idxs, event) => {
            onSelectBoxSelection({
                event,
                setActiveIndex,
                idxs,
                selectedIdxs,
                selectingIdxs,
                storage,
                setSelectingIdxs,
                dispatch,
                prevSelectHandler,
            });
        },
        [dispatch, setSelectingIdxs, selectingIdxs, setActiveIndex, storage, selectedIdxs]
    );

    const handleSelecting = useCallback(
        (idxs) => {
            onSelecting({ setActiveIndex, idxs, selectingIdxs, setSelectingIdxs });
        },
        [selectingIdxs, setSelectingIdxs]
    );

    const handleOnClick = useCallback(
        (id, item) => {
            onItemClick({ id, item, goTo, dispatch, storage, viewMode, attachType, attachFolderId, currentAllDocsType });
        },
        [goTo, dispatch, routerParams, viewMode, attachType, attachFolderId]
    );

    const handleClickCreateNew = useCallback(
        (e) => {
            onClickCreateNew(e, { gaSuffix, storage, currentAllDocsType });
        },
        [storage, currentAllDocsType]
    );

    return {
        handleOnDocumentClick,
        handleOnSelectGroupClick,
        handleBeginSelection,
        handleOnContextMenu,
        handleOnContextMenuItem,
        handleOnSelect,
        handleSelectboxSelection,
        handleSelecting,
        handleOnClick,
        handleClickCreateNew,
    };
};
